export default __webpack_public_path__ + "static/media/others-page1400.458f1802.jpg";